<template>
	<div id="standMap">
		<div id="map-con" class="clearfloat">
			<div class="filter marginT10 marginB10 right">
				<el-cascader
					class="filterInput"
					clearable
					size="mini"
					v-model.trim="place"
					placeholder="省/市/区"
					:options="ssq"
				></el-cascader>
				<el-select
					class="filterInput"
					size="mini"
					v-model.trim="filterForm.online"
					clearable
					placeholder="在离线"
				>
					<el-option label="在线" :value="true"></el-option>
					<el-option label="离线" :value="false"></el-option>
				</el-select>
				<el-input
					class="filterInput"
					size="mini"
					v-model.trim="filterForm.macSn"
					clearable
					placeholder="mac或sn"
				></el-input>
				<el-select
					class="filterInput"
					size="mini"
					v-model.trim="filterForm.brand"
					clearable
					placeholder="品牌"
				>
					<el-option
						v-for="item in $store.state.standard.brands"
						:key="item.value"
						:label="item.label"
						:value="item.value"
					></el-option>
				</el-select>
				<el-button
					icon="el-icon-search"
					size="mini"
					type="primary"
					class="marginL10"
					@click="getDeviceMap"
				></el-button>
			</div>
			<div ref="wrapper" id="wrapper"></div>
		</div>
	</div>
</template>

<script>
import ssq from "../../assets/js/citys";
export default {
	data() {
		return {
			ssq,
			place: [],
			filterForm: {
				online: null,
				brand: null,
				macSn: null,
			},
			map: null,
			infoWindow: null,
			markers: [],
			cluster: null,
			marker: {},
		};
	},
	mounted() {
		this.map = new AMap.Map("wrapper", {
			resizeEnable: true,
			zoom: 8,
		});
		this.getDeviceMap();
	},
	methods: {
		getDeviceMap() {
			if (this.markers.length > 0) {
				let that = this;
				for (let i in this.markers) {
					this.map.remove(that.markers[i]);
				}
				this.map.remove(that.cluster);
				this.markers = [];
				this.cluster = null;
				this.map.clearMap();
			}
			this.$nextTick(() => {
				let form = {
					province: this.place[0] ? this.place[0] : "",
					city: this.place[1] ? this.place[1] : "",
					district: this.place[2] ? this.place[2] : "",
					...this.filterForm,
				};
				this.$http.standardDeviceMap(form).then((res) => {
					if (res.data.success) {
						this.addMarker(res.data.data);
					}
				});
			});
		},
		addMarker(mapArry) {
			let that = this,
				arr = Object.assign([], mapArry);
			for (var i = 0; i < arr.length; i++) {
				if (arr[i].location && arr[i].location.coordinates) {
					let content =
						"<i class='iconaddress map' style='color:#60ACFC'></i>";
					if (!arr[i].online) {
						content =
							"<i class='iconaddress map' style='color:#708090'></i>";
					}
					this.marker = new AMap.Marker({
						position: arr[i].location.coordinates, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
						content: content,
						map: that.map,
						data: arr[i],
					});
					AMap.event.addListener(
						that.marker,
						"mouseover",
						function (e) {
							that.openInfo(e);
						}
					);
					this.markers.push(that.marker);
				}
			}
			var sts = [
				{
					url: require("../../assets/imges/mapAdree.png"),
					size: new AMap.Size(48, 48),
					textColor: "#fff",
					offset: new AMap.Pixel(-16, -16),
				},
				{
					url: require("../../assets/imges/mapAdree.png"),
					size: new AMap.Size(48, 48),
					textColor: "#fff",
					offset: new AMap.Pixel(-16, -16),
				},
				{
					url: require("../../assets/imges/mapAdree.png"),
					size: new AMap.Size(48, 48),
					textColor: "#fff",
					offset: new AMap.Pixel(-18, -18),
				},
				{
					url: require("../../assets/imges/mapAdree.png"),
					size: new AMap.Size(48, 48),
					textColor: "#fff",
					offset: new AMap.Pixel(-24, -24),
				},
				{
					url: require("../../assets/imges/mapAdree.png"),
					size: new AMap.Size(48, 48),
					textColor: "#fff",
					offset: new AMap.Pixel(-24, -24),
				},
			];
			this.map.plugin(["AMap.MarkerClusterer"], function () {
				that.cluster = new AMap.MarkerClusterer(
					that.map,
					that.markers,
					{
						styles: sts,
						gridSize: 5,
					}
				);
			});
		},
		openInfo(e) {
			// 校验是否有查看设备详情权限
			let menuList = Object.assign(
					[],
					this.$store.state.standard.menuNodeList
				), // 权限树
				flag = false; // 标示权限与否
			for (let i in menuList) {
				if (menuList[i].href == "/standardDevice/deviceDetail") {
					flag = true;
					break;
				}
			}
			//构建信息窗体中显示的内容
			var info = [];
			var that = this;
			info.push(
				'<div style="padding:0px 0px 0px 4px;"><font style="width: 15px;height: 15px;display: block;float: left;border-radius: 50%;background: ' +
					(e.target.Ce.data.online
						? "#60ACFC"
						: "rgb(225, 227, 231)") +
					';margin: 2px 8px 0 0;"></font><b style="color:' +
					(e.target.Ce.data.online
						? "#60ACFC"
						: "rgb(225, 227, 231)") +
					'">' +
					(e.target.Ce.data.online ? "在线" : "离线") +
					"</b>"
			);
			info.push(
				"<div class='infoTxt'>SN：" + e.target.Ce.data.sn + "</div>"
			);
			info.push(
				"<div class='infoTxt'>MAC : " + e.target.Ce.data.mac + "</div>"
			);
			info.push(
				"<div class='infoTxt'>产品类型 : " +
					e.target.Ce.data.productType.productType +
					"</div>"
			);
			info.push(
				"<div class='infoTxt'>产品型号 : " +
					e.target.Ce.data.product.productModel +
					"</div>"
			);
			if (flag) {
				info.push(
					"<a class='standardMap-more' data-id='" +
						e.target.Ce.data.id +
						"'>更多</a></div></div>"
				);
			}
			that.infoWindow = new AMap.InfoWindow({
				content: info.join("<br/>"), //使用默认信息窗体框样式，显示信息内容
				autoMove: true,
				offset: new AMap.Pixel(0, -25),
			});
			that.infoWindow.open(that.map, e.target.getPosition());
		},
	},
};
</script>

<style lang="less">
#standMap {
	height: 100%;
	width: 100%;
	float: left;
	background: #ffffff;
	box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.05);
	border-radius: 4px;
	#map-con {
		margin: 8px;
		height: calc(100% - 16px);
		width: calc(100% - 16px);
	}
	#wrapper {
		height: 100%;
		width: 100%;
	}
	.filterInput {
		width: 200px;
		margin-left: 10px;
	}
	.standardMap-more {
		color: #0000ff;
		cursor: pointer;
		font-size: 14px;
	}
	.infoTxt {
		font-size: 14px;
		line-height: 25px;
		display: inline-block;
	}
}
</style>
